import { hot } from "react-hot-loader/root";
import React, { useEffect } from "react";
import { Tabs as MatchboxTabs, useTabs } from "@sparkpost/matchbox";
import LoadingIndicator from "./LoadingIndicator";
import { i18n } from "../utils/utils";
import { Metrics, Logs, DNS, Settings } from "../tabs";
import { useAppState } from "../utils/context";

const tabsList = [
  { title: i18n("Tabs.Metrics"), component: Metrics, slug: "metrics" },
  { title: i18n("Tabs.Logs"), component: Logs, slug: "logs" },
  { title: i18n("Tabs.DNS"), component: DNS, slug: "dns" },
  { title: i18n("Tabs.Settings"), component: Settings, slug: "settings" },
];

const initialTabIndex =
  tabsList.findIndex((tab) => tab.slug === window.WPMailPro.data.current_tab) ||
  0;

const updateAdminMenuOnTabSelection = (index) => {
  const currentMenuLink = document.querySelector(
    "ul#adminmenu li#toplevel_page_wpmailpro ul.wp-submenu li.current"
  );
  const menuLink = document.querySelector(
    `ul#adminmenu li#toplevel_page_wpmailpro ul.wp-submenu li a[href$=${tabsList[index].slug}]`
  );
  const menuLinkLi = menuLink.parentNode;

  if (currentMenuLink) {
    currentMenuLink.classList.remove("current");
  }

  if (menuLinkLi) {
    menuLinkLi.classList.add("current");
  }
};

const Tabs = () => {
  const { hideNotice } = useAppState();

  const { tabIndex, setTabIndex, tabs } = useTabs({
    tabs: tabsList.map((tab) => ({
      content: tab.title,
    })),
  });

  useEffect(() => {
    setTabIndex(initialTabIndex);
    updateAdminMenuOnTabSelection(initialTabIndex);
  }, []);

  const onTabSelect = (tabIndex) => {
    updateAdminMenuOnTabSelection(tabIndex);

    setTabIndex(tabIndex);
    hideNotice();
  };

  return (
    <>
      <nav className="plugin-tabs">
        <MatchboxTabs
          selected={tabIndex}
          tabs={tabs}
          onSelect={onTabSelect}
          fitted
        />
      </nav>

      {tabsList.map((tab, i) => {
        if (i !== tabIndex) {
          return null;
        }

        const TabContent = tab.component;

        return (
          <div className="tab-content" key={`tabContent${i}`}>
            <TabContent />
            <LoadingIndicator />
          </div>
        );
      })}
    </>
  );
};

export default hot(Tabs);
